import { useEffect } from 'react';
import { useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useToastActions } from 'common/services/toast-service/hooks';
export var FormErrorsToast = function (_a) {
    var title = _a.title, message = _a.message;
    var t = useTranslation().t;
    var addErrorToast = useToastActions().addErrorToast;
    var _b = useFormState(), submitFailed = _b.submitFailed, valid = _b.valid, submitErrors = _b.submitErrors;
    useEffect(function () {
        if (submitFailed && !valid && (!submitErrors || !Object.keys(submitErrors).length)) {
            addErrorToast({
                title: title || t('common.formErrorsToastDef.title'),
                message: message || t('common.formErrorsToastDef.message'),
            });
        }
    }, [addErrorToast, t, submitFailed, submitErrors, message, title]);
    return null;
};
